import {Button, Col, Form, InputGroup, Row} from "react-bootstrap";
import dashboard from "../../../../assets/img/dashboard.webp";
import React, {useState} from "react";
import "./WithSubscribe.css";
import {useTranslation} from "react-i18next";
import hostname from "../../../../hostname";
import {Captcha} from "../../common/Captcha";

const WithSubscribe = () => {
    const {t} = useTranslation();

    const [termsAgreed, setTermsAgreed] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [formState, setFormState] = useState('initial');
    const [errorMessage, setErrorMessage] = useState(null);

    function onFormSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const formData = new FormData(event.target);
        const email = formData.get("email");
        setErrorMessage("");

        if (!termsAgreed) {
            setErrorMessage("Please agree to the terms");
            setFormState("error");
            return;
        }

        if (!captchaVerified) {
            setErrorMessage("Please verifiy captcha");
            setFormState("error");
            // todo show error
            return;
        }

        if ("" === email.trim()) {
            setErrorMessage("The email address is not valid");
            setFormState("error");
            return;
        }

        setFormState('loading');

        fetch(
            hostname + '/index.php/email/collect',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1Y2Fyc29sdXRpb25zIiwiYXVkIjp7InR5cGUiOiJ1Y2Fyc29sdXRpb25zIiwidmFsdWUiOiI2ZGYxZGNiZS00Yzk2LTQyN2UtOTMwNy02MjNlODkzOWI2ODQifSwiaWF0IjoxNzUwNDI4MzE5LCJuYmYiOjE3NTA0MjgzMTh9.1pL9dfI10xsCNTRIPsDevHmXhlPtzGFrHB_fYLCCqko"
                },
                body: JSON.stringify({email: email.trim()}),
            })
            .then(response => {
                if (!response.ok) {
                    console.warn('Server returned an error:', response.status);
                    setFormState('error');
                    return;
                }
                setFormState('success');
                resetForm();
            })
            .catch(error => {
                console.error('Error during API call:', error);
                setFormState('error');
                resetForm();
            });
    }

    function resetForm() {
        setTimeout(() => setFormState('initial'), 5000);
    }

    return (<section
        className="row align-items-center text-center text-lg-start ps-4 pe-4 pt-5 pb-5 g-5"
        aria-labelledby="hero-newsletter"
    >
        <Col xs={12} lg={6} className="px-lg-5">
            <h1
                id="hero-newsletter"
                className="display-4 fw-bold text-uppercase mb-3"
                dangerouslySetInnerHTML={{__html: t("pages.home.hero.withSubscribe.title")}}
            />
            <p className="lead mb-4">
                {t("pages.home.hero.withSubscribe.subTitle")}
            </p>
            <Form className="d-grid gap-3" onSubmit={onFormSubmit}>
                <InputGroup size="lg">
                    <Form.Control
                        aria-label="Email"
                        type="email"
                        placeholder={t("pages.home.hero.withSubscribe.form.input.placeholder")}
                        name="email"
                        disabled={!termsAgreed}
                    />
                </InputGroup>

                <Row className="align-items-center g-2">
                    <Col xs={12} md={6}>
                        <Form.Check
                            required
                            label={t("pages.home.hero.withSubscribe.form.checkBox.consent")}
                            onClick={() => setTermsAgreed(!termsAgreed)}
                            feedback={t("pages.home.hero.withSubscribe.form.checkBox.feedback")}
                            feedbackType="invalid"
                        />
                    </Col>
                    <Col xs={12} md={6} className="text-md-end">
                        <Captcha
                            onSolutionRejected={() => setCaptchaVerified(false)}
                            onSolutionVerified={() => setCaptchaVerified(true)}
                        ></Captcha>
                    </Col>
                </Row>

                <div className="d-grid mt-3">
                    <Button type="submit" className="text-white" disabled={formState === 'loading'}>
                        {t("pages.home.hero.withSubscribe.form.button.text")}
                    </Button>
                </div>

                <div className="mt-2">
                    <small className={formState === 'success' ? "text-success" : "d-none"}>
                        {t("pages.home.hero.withSubscribe.form.success")}
                    </small>
                    <small className={formState === 'error' ? "text-danger" : "d-none"}>
                        {errorMessage || t("pages.home.hero.withSubscribe.form.error")}
                    </small>
                </div>
            </Form>
        </Col>
        <Col xs={12} lg={6} className="text-center">
            <img
                src={dashboard}
                alt={t("pages.home.hero.withSubscribe.dashboardImage.alt")}
                className="img-fluid rounded shadow w-100"
                loading={"lazy"}
            />
        </Col>
    </section>);
};

export default WithSubscribe;
